module.exports = __webpack_public_path__ + "img/Responsiveness-2021.18413c82.png";